// WHERE THE SIGN-OFF PAGES SHOW. Owner 2026-10-30: "hide 3D volume and sign-off timeline
// from prod until fully tested on predeployment" - they showed on predeployment (and a local
// dev server) only. Owner 2026-11-01: "enable the sign-off feature in all the places on
// prod" - RELEASED: the Sign-off timeline, the Sign-off tab on Coordination and
// the emailed /s/ link page show on every host. The switch stays, so hiding them again is
// one line: return SHOWN_ON.test(host) below.
// eslint-disable-next-line no-unused-vars
const SHOWN_ON = /^(predeployment\.|localhost$|127\.0\.0\.1$)/i;

// eslint-disable-next-line no-unused-vars
export function signoffPagesOn(host = typeof window !== "undefined" && window.location ? window.location.hostname : "") {
  return true;
}
